// Copyright 2018 Sorama B.V.

import { autoinject, bindable, BindingEngine, customElement, Disposable } from "aurelia-framework";
import { MeasurementWorkflowModuleCatalog } from "catalogs/WorkflowModuleCatalog/MeasurementModuleCatalog";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";

export class AlertContent {
    public alertType: string;
    public alertText: string;
    public alertSubText: string;
    public alertIcon: string;
    public secondaryIcon: string;
    public alertLink?: boolean;
}

@customElement("multi-alert")
@autoinject
export class MultiAlert {
    @bindable()
    private alertContent: AlertContent[];

    private sortedAlerts: AlertContent[] = [];

    private currentIndex = 0;

    private bindingEngine: BindingEngine;
    private bindingDisposable: Disposable;

    constructor(
        bindingEngine: BindingEngine,
        private readonly shellViewManager: ShellViewManager
    ) {
        this.bindingEngine = bindingEngine;
    }

    private bind(): void {
        this.orderAlertContents();

        if (this.alertContent) {
            this.bindingDisposable = this.bindingEngine
                .collectionObserver(this.alertContent)
                .subscribe(() => this.orderAlertContents());
        }
    }

    private unbind() {
        if (this.bindingDisposable) {
            this.bindingDisposable.dispose();
        }
    }

    private alertContentChanged(): void {
        this.orderAlertContents();

        if (this.bindingDisposable) {
            this.bindingDisposable.dispose();
        }

        this.bindingDisposable = this.bindingEngine
            .collectionObserver(this.alertContent)
            .subscribe(() => this.orderAlertContents());
    }

    private orderAlertContents(): void {
        this.currentIndex = -1; // small trick to make sure that everything updates
        this.currentIndex = 0;
        this.sortedAlerts.splice(0, this.sortedAlerts.length);
        this.alertContent.filter((x) => x.alertType == "alert-danger").map((x) => this.sortedAlerts.push(x));
        this.alertContent.filter((x) => x.alertType == "alert-warning").map((x) => this.sortedAlerts.push(x));
        this.alertContent.filter((x) => x.alertType == "alert-success").map((x) => this.sortedAlerts.push(x));
        this.alertContent.filter((x) => x.alertType == "alert-info").map((x) => this.sortedAlerts.push(x));
    }
    public editProject(): void {
        this.shellViewManager.openRightSideBar(MeasurementWorkflowModuleCatalog.ProjectManagementModule);
    }
}
